import { ICustomer, IInquiry, IInventory, IOrder } from "../types";
export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  RESET_PASSWORD: "/reset-password",
  MANAGE_COLORS: "/manage-colors",
  MANAGE_COUNTRY: "/manage-countries",
  MANAGE_DISCOUNT: "/manage-discount",
  INVENTORY_DETAIL: "/inventory/:id",
  INQUIRY_DETAIL: "/inquiry/:id",
  CUSTOMER_DETAIL: "/customer/:id",
  ORDER_DETAIL: "/order/:id",
};

export const THEME = {
  PRIMARY_COLOR: "#764C24",
  SPACING: { SM: 8, MD: 16 },
};

export const inventoryColumns = [
  {
    key: "serial_id",
    label: "Stock Number",
  },
  {
    key: "color",
    label: "Color",
  },
  {
    key: "clarity",
    label: "Grade",
  },
  {
    key: "carat",
    label: "Cts.",
  },
  {
    key: "price_per_carat",
    label: "P/ct",
  },
  {
    key: "certificate_number",
    label: "Certificate",
  },
];

export const InventoryDetail = {
  id: 1,
  stockNumber: "VDB-10525563",
  shape: "Round",
  color: "E",
  carat: 12.52,
  price_per_carat: 400,
  total_price: 5008,
  clarity: "VS2",
  ratio: "-",
  lab: "IGI",
  cut: "Ideal",
  polish: "Excellent",
  symmetry: "Excellent",
  depth_percentage: 60.1,
  table_percentage: 59,
  fluorescent: "None",
  culet: "-",
  girdle: "Medium",
  certificate_number: "585390266",
  location: "New York, United States",
  created_at: "2025-05-09T10:30:00Z",
  updated_at: "2025-05-09T10:30:00Z",
  status: "Available",
  is_lab_grown: true,
};

export const customerColumns = [
  { key: "business_name", label: "Business Name" },
  { key: "owner_name", label: "Customer Name" },
  { key: "phone", label: "Phone" },
  { key: "user_email", label: "Email" },
  { key: "address", label: "Address" },
  { key: "created_at", label: "Date" },
  { key: "status", label: "Status" },
];

export const customerDetail = {
  businessName: "Craxinno Technologies",
  ownerName: "Marcus Lane",
  ownerPhoneNumber: "91-9983098709",
  ownerEmail: "marcuslane@gmail.com",
  phone: "020-317-7682",
  email: "info@craxinno.com",
  addressLine1: "D Street, Hudson Bay Lane",
  addressLine2: "Near Tallahassee",
  suiteAndBuilding: "Suite 201, Tech Park",
  city: "Tallahassee",
  country: "USA",
  stateProvince: "Florida",
  postalCode: "32301",
  website: "https://craxinno.com",
  taxIdNumber: "GST-123456789",
  governmentLicenseNumber: "LIC-987654321",
  resaleCertificateNumber: "RCN-456789123",
  governmentIdImage: "https://placehold.co/80x80/png?text=ID",
  businessLicenseImage: "https://placehold.co/80x80/png?text=License",
};

export const inquiryColumns = [
  { key: "created_at", label: "Date" },
  { key: "business_name", label: "Business Name" },
  { key: "owner_name", label: "Customer Name" },
  { key: "owner_phone", label: "Contact Number" },
  { key: "item_count", label: "Item Count" },
];

export const inquiriesTableData: IInquiry[] = [
  {
    id: 1,
    date: "06-05-2025",
    businessName: "John Doe",
    customerName: "John Doe",
    contactNumber: "555-1111",
    itemCount: 3,
  },
  {
    id: 2,
    date: "06-06-2025",
    businessName: "Jane Smith",
    customerName: "Jane Smith",
    contactNumber: "555-2222",
    itemCount: 1,
  },
];

export const COLORS = [
  "Rose",
  "Champagne",
  "Cognac",
  "Canary",
  "Olive",
  "Emerald",
  "Sapphire",
  "Ruby",
  "Amethyst",
  "Topaz",
  "Jade",
  "Coral",
  "Ivory",
  "Onyx",
  "Pearl",
  "Amber",
  "Turquoise",
  "Mint",
  "Lavender",
  "Peach",
  "Slate",
  "Sand",
  "Moss",
  "Sky",
  "Berry",
];

export const COUNTRIES = [
  "United States",
  "Canada",
  "Mexico",
  "Brazil",
  "Argentina",
  "United Kingdom",
  "France",
  "Germany",
  "Italy",
  "Spain",
  "Netherlands",
  "Sweden",
  "Norway",
  "Australia",
  "India",
];

export const bookingColumns = [
  { key: "name", label: "Name" },
  { key: "designation", label: "Designation" },
  { key: "business", label: "Business" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" },
  { key: "location", label: "Location" },
  { key: "status", label: "Status" },
  { key: "slot_date", label: "Date" },
  { key: "slot_time", label: "Time" },
];
